export const getGamesBehindDisplay = (gamesBehind) => {
  if (gamesBehind === undefined || gamesBehind === null) return '-';
  return gamesBehind === 0 ? '-' : gamesBehind.toFixed(1);
};

export const getMarginDisplay = (margin) => {
  return margin !== undefined && margin !== null ? margin.toFixed(1) : '0.0';
};

export const getWinPctDisplay = (wins, losses) => {
  const totalGames = (wins || 0) + (losses || 0);
  if (totalGames === 0) return '0.0%';
  return `${(((wins || 0) / totalGames) * 100).toFixed(1)}%`;
};

export const getBestPossibleDisplay = (bestPossible, currentLosses, effectiveLosses) => {
  if (bestPossible === undefined || bestPossible === null) return '-';
  const displayLosses = effectiveLosses !== undefined ? effectiveLosses : currentLosses;
  return `${bestPossible}-${displayLosses ?? 0}`;
};

export const getLocksRemainingDisplay = (locksRemaining) => {
  if (locksRemaining === undefined || locksRemaining === null) return '-';
  return locksRemaining;
};

export const parseRankNumber = (rank) => {
  if (rank === undefined || rank === null || rank === 'TBD') return Number.MAX_SAFE_INTEGER;
  if (typeof rank === 'string' && rank.startsWith('T')) {
    return parseInt(rank.substring(1), 10);
  }
  return Number(rank);
};

export const mergeStandingsUsers = (leaderboardUsers, allActiveUsers, settings, weekStructure) => {
  if (!leaderboardUsers || !Array.isArray(leaderboardUsers)) {
    return [];
  }

  if (!allActiveUsers?.length) {
    return leaderboardUsers;
  }

  const existingUsers = new Set(leaderboardUsers.map((user) => user.username));
  const missingUsers = allActiveUsers.filter((username) => !existingUsers.has(username));

  if (missingUsers.length === 0) {
    return leaderboardUsers;
  }

  const byeWeekRequired = settings?.bye_week_required;
  const locksRemaining = byeWeekRequired ? '20+Bye' : '21';

  const missingUserData = missingUsers.map((username) => ({
    username,
    rank: 'TBD',
    wins: 0,
    losses: 0,
    bye_used: 0,
    effective_losses: 0,
    accumulated_margin: 0,
    average_margin: 0,
    locks_remaining: locksRemaining,
    best_possible: 20,
    fav_pics: 0,
    dog_picks: 0,
    pk_picks: 0,
    over_picks: 0,
    under_picks: 0,
    weeks: weekStructure
      ? weekStructure.map((week) => ({
          weekNumber: week.weekNumber,
          status: 'none',
        }))
      : [],
  }));

  return [...leaderboardUsers, ...missingUserData];
};

export const shouldShowStandingsStaleBanner = ({
  hasReachedMaxPicks,
  showLockers,
  season,
  effectiveSeason,
}) => !hasReachedMaxPicks && !showLockers && season === effectiveSeason;

export const getStandingsStaleMessage = (currentWeek) => {
  if (currentWeek === 1) {
    return 'Week 1 standings will be available once you complete your lock.';
  }
  const previousWeek = currentWeek > 1 ? currentWeek - 1 : 1;
  return `Standings reflect rankings as of the end of Week ${previousWeek}. Live standings will appear after you complete your lock.`;
};
